import { render, staticRenderFns } from "./ThreeTable.vue?vue&type=template&id=37a9de89&scoped=true"
import script from "./ThreeTable.vue?vue&type=script&lang=js"
export * from "./ThreeTable.vue?vue&type=script&lang=js"
import style0 from "./ThreeTable.vue?vue&type=style&index=0&id=37a9de89&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37a9de89",
  null
  
)

export default component.exports